'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const{IncidentTooltipDirectiveController:IncidentTooltipDirectiveController}=require('./incidentTooltipDirective');

const alignmentOptions={
anchorToTargetSide:'top',
alignFromTooltipSide:'bottom'};let


FleetIncidentTooltipDirective=function(_BaseControllerBacked){_inherits(FleetIncidentTooltipDirective,_BaseControllerBacked);function FleetIncidentTooltipDirective(){_classCallCheck(this,FleetIncidentTooltipDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FleetIncidentTooltipDirective,[{key:'objectBindings',get:function()
{
return[
'person',
'fatigueThresholdStatus',
'deviationThresholdStatus',
'deviation',
'fatigue',
'time',
'description',
'timezone',
'targetElement',
'isActive',
'incident'];

}},{key:'templateUrl',get:function()

{
return'/templates/directives/tooltips/incidentTooltip/incidentTooltipTemplate';
}},{key:'controller',get:function()

{
return FleetIncidentTooltipDirectiveController;
}}]);return FleetIncidentTooltipDirective}(BaseControllerBackedDirective);let


FleetIncidentTooltipDirectiveController=function(_IncidentTooltipDirec){_inherits(FleetIncidentTooltipDirectiveController,_IncidentTooltipDirec);_createClass(FleetIncidentTooltipDirectiveController,null,[{key:'$inject',get:function()
{
return['timeFormattingService','$element','$timeout','tooltipService','elementService'];
}}]);

function FleetIncidentTooltipDirectiveController(timeFormattingService,$element,$timeout,tooltipService,elementService){_classCallCheck(this,FleetIncidentTooltipDirectiveController);var _this2=_possibleConstructorReturn(this,
_IncidentTooltipDirec.call(this,timeFormattingService));

tooltipService.updateTooltipPosition(alignmentOptions,_this2.targetElement,$element.parent());
$timeout(function(){
if(!_this2.isActive){
return;
}

elementService.addClass($element,'open');
},100);return _this2;
}return FleetIncidentTooltipDirectiveController}(IncidentTooltipDirectiveController);


module.exports=FleetIncidentTooltipDirective;
//# sourceMappingURL=fleetIncidentTooltipDirective.js.map
